







import { EventBus } from '@/libs/com/MetaPattern/Product/IDE/Util/EventBus';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class MessageScopeTool extends Vue {
  isExpend = true;

  handle() {
    this.isExpend = !this.isExpend;
    EventBus.$emit('messageScope:command', 'expend', this.isExpend);
  }
}
